window.global ||= window;

export default {};
